import { safeStorage } from '@ctcells/core'
import { useCallback, useState } from 'react'

/**
 * 2026-10-28 eric 결정으로 칸 제목 · 접기: 제목줄에서 접고 왼쪽 세로 띠에서 펼친다.
 * 기존 브라우저 저장 키와 기본값을 유지하며, 저장소가 막히면 이번 화면 동안만 기억한다.
 */
export type MonitorColumn = 'samples' | 'equipment' | 'vision' | 'supply'

export const MONITOR_COLUMNS: readonly MonitorColumn[] = [
  'samples',
  'equipment',
  'supply',
  'vision',
]

/**
 * 처음 꺼진 열 — 「비전」(원심 · 어셈블러 · 염색기 영상 셋을 위에서 아래로 · eric 2026-10-12 「장비와 소모품 사이에 비전 체크박스..
 * 세 개의 영상을 동시에」). 🔴 영상 스트림 셋이 늘 열리지 않게 켜는 사람만 본다 — 켜면 그 브라우저가 기억한다
 */
const OFF_BY_DEFAULT: ReadonlySet<MonitorColumn> = new Set(['vision'])

const HIDDEN = 'hidden'
const SHOWN = 'shown'

/** 끔 기억 키 — 열 이름이 키에 든다 */
export function columnStorageKey(column: MonitorColumn): string {
  return `ctcells.monitoring.hidden.${column}.v1`
}

export function useColumnShown(column: MonitorColumn): {
  shown: boolean
  setShown: (next: boolean) => void
} {
  const key = columnStorageKey(column)
  const offByDefault = OFF_BY_DEFAULT.has(column)
  const [shown, setState] = useState(() => {
    const saved = safeStorage.read(key)
    return offByDefault ? saved === SHOWN : saved !== HIDDEN
  })
  const setShown = useCallback(
    (next: boolean) => {
      /* 기본값과 같으면 지운다 — 기본과 다를 때만 값이 남는다 */
      if (next !== offByDefault) safeStorage.remove(key)
      else safeStorage.write(key, next ? SHOWN : HIDDEN)
      setState(next)
    },
    [key, offByDefault],
  )
  return { shown, setShown }
}
